<template>
	<div class="body">
		<div class="body-container">

			<div class="right-content">
				<div class="content-title" v-if="title">
					<img class="title-wing" src="../../assets/icons/title_wing_left.png" />
					<span class="title-text">{{title}}</span>
					<img class="title-wing" src="../../assets/icons/title_wing_right.png" />
				</div>

				<div class="match-ctr">
					<div class="login-ctr" v-if="hasLogin == 2">
						<div class="login-tips">该功能需要登录后才能使用</div>
						<el-button class="to-login" type="primary" icon="el-icon-s-custom"
							@click="clickLogin">点击登录</el-button>
					</div>
					<template v-else-if="hasLogin == 1">
						<div class="match-create-ctr">
							<el-button type="primary" icon="el-icon-plus" size="medium"
								@click="createUserMatch()">新建</el-button>
						</div>
						<el-table border :data="dataList">
							<el-table-column label="学校名称" align="center" prop="province_name" min-width="2">
								<template v-slot="{ row }">
									<label>{{row.college.name}}</label>
								</template>
							</el-table-column>
							<el-table-column label="专业层次" align="center" prop="level" min-width="1" />
							<el-table-column label="省(区市)" align="center" prop="provinceNames" min-width="2" />
							<el-table-column label="专业" align="center" prop="majorNames" min-width="3" />
							<el-table-column label="状态" align="center" prop="stateName" min-width="1" />
							<el-table-column label="创建日期" align="center" prop="created_at" min-width="2" />
							<el-table-column label="操作" align="center" prop="province_name" min-width="3">
								<template v-slot="{ row }">
									<el-button v-if="row.state == 2 || row.state == 3" type="primary"
										icon="el-icon-reading" size="small" class="el-button--success"
										@click="clickMatch(row)">查看</el-button>
									<el-button v-else type="primary" icon="el-icon-reading" size="small"
										class="el-button--warning" @click="clickMatch(row)">分析</el-button>


									<el-button type="primary" icon="el-icon-delete" size="small"
										class="el-button--danger" @click="clickDel(row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						
						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="requestMajorMatchList" />
						</div>
					</template>
				</div>
			</div>
		</div>

		<el-dialog :visible.sync="showMatchDialog" title="新建产业分析报告" align='center'>
			<div class="create-group-ctr">

				<div class="group-row" v-if="college">
					<label>院校名称</label>

					<el-input disabled class="group-input" :value="college.name" />
				</div>
				<div class="group-row" v-else>
					<label>院校名称</label>
					<el-select v-model="college_id" placeholder="请输入院校名称" class="select-width" filterable remote
						reserve-keyword :remote-method="loadCollegeList" :clearable=true>
						<el-option v-for="item in collegeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>专业层次</label>
					<el-select v-model="level" placeholder="请选择专业的层次" class="group-select" filterable
						@change="onLevelChange">
						<el-option v-for="item in levelList" :key="item.name" :label="item.name + '专业'" :value="item.name">
						</el-option>
					</el-select>
				</div>

				<div class="group-row" v-if="type == 'group'">
					<label>专业群名</label>

					<el-input v-model="groupName" class="group-input" placeholder="请输入专业群名称" />
				</div>

				<div class="group-row">
					<label>专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业</label>
					<template v-if="type == 'group'">
						<el-select class="group-select" v-model="majors" placeholder="请选择" :clearable=true filterable
							multiple :multiple-limit="6">
							<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
						<span>最多选6个</span>
					</template>
					<template v-else-if="type == 'single'">
						<el-select class="group-select" v-model="majors" placeholder="请选择" :clearable=true filterable>
							<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</template>
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="provinces" placeholder="请选择" :clearable=true filterable
						multiple :multiple-limit="3">
						<el-option v-for="item in provinceList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
					<span>最多选3个</span>
				</div>

			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateMatch()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getIndustryConfig,
		getIndustryPageData,
		createIndustryReport,
		deleteIndustryReport
	} from "@/api/report"

	import {
		queryAllCollege,
		getMajorList
	} from "@/api/matrix"

	import {
		isEmpty,
		setLocalData,
		getLocalData
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Service",
		data() {
			return {
				name: '',
				provinces: [],
				majors: [],
				provinceList: [],
				showMatchDialog: false,
				dataList: [],
				collegeList: [],
				college: null,
				queryParams: {
					page: 1,
					pageSize: 20
				},
				title: '',
				level: '',
				hasLogin: 3,
				levelList: [],
				majorList: [],
				college_id: '',
				groupName: '',
				total: 0,
				type: ''
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.type = this.$route.query.type;
				if(this.type == 'single'){
					this.majors = '';
				}
				this.requestMajorMatchList();
				this.loadConfig();
			},

			requestMajorMatchList() {
				getIndustryPageData(this.buildParams()).then(res => {
					this.hasLogin = res.data.hasLogin;
					if (this.hasLogin == 1) {
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
					}
				});
			},

			loadConfig() {
				getIndustryConfig(this.buildParams()).then(res => {
					this.provinceList = res.data.provinceList;
					this.college = res.data.college;
					this.levelList = res.data.levelList;
					this.title = res.data.title;
				});
			},


			loadCollegeList(name) {
				let params = {
					name: name
				}

				if (this.province) {
					params['province_code'] = this.province
				}

				if (this.city) {
					params['city_code'] = this.city
				}

				queryAllCollege(params).then(res => {
					this.collegeList = res.data.list;
				});
			},

			buildParams() {

				let provinces = this.provinces.join(',')
				
				let majors = this.majors;
				if(this.type != 'single'){
					majors = this.majors.join(',')
				}

				if (this.college) {
					this.queryParams['college_id'] = this.college['id'];
				} else {
					this.queryParams['college_id'] = this.college_id;
				}
				this.queryParams['type'] = this.type;
				this.queryParams['level'] = this.level;
				this.queryParams['provinces'] = provinces;
				this.queryParams['majors'] = majors;
				this.queryParams['group_name'] = this.groupName;

				return this.queryParams;
			},


			onLevelChange(value) {
				this.majorList = [];
				if(this.type == 'single'){
					this.majors = '';
				}else if(this.type == 'group'){
					this.majors = [];
				}
				
				getMajorList({
					'degree': value,
					'from': 'report_industry'
				}).then(res => {
					this.majorList = res.data.majorList;
				})
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			clickCloseDialog() {
				this.showMaterialDialog = false;
			},

			changeProvince(value) {
				let id = this.curMenu.id;

				if (id == this.Channel.Industry) {
					// this.requestThirdIndustryData();
				} else if (id == this.Channel.EduData) {
					// this.requestEduData();
				} else if (this.showMaterialDialog) {
					this.requestMaterialData();
				}
			},

			//-----------match----------	

			createUserMatch() {
				this.college_id = '';
				this.groupName = '';
				if(this.type == 'single'){
					this.majors = '';
				}else{
					this.majors = [];
				}
		
				this.provinces = [];
				this.level = '';
				this.showMatchDialog = true;
			},

			confirmCreateMatch() {
				createIndustryReport(this.buildParams()).then(res => {
					this.showMatchDialog = false;
					this.requestMajorMatchList();
				})
			},

			clickMatch(row) {
				let path = '/industry_report?id=' + row.id;
				this.$router.push(path);
			},

			clickDel(row) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					deleteIndustryReport({
						'id': row.id
					}).then(res => {
						this.requestMajorMatchList();
					})
				})
			},

			clickLogin() {
				this.loginStore.openLoginDialog()
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "industry_index.scss";
</style>